import { createContext, useContext } from 'react';

/** True in mock mode, so screens can mark data as example data. */
export const MockFlagContext = createContext(false);
export const useIsMock = () => useContext(MockFlagContext);
